import { useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Card from "../Card/Card";
import CardRadioSelect from "../CardRadioSelect/CardRadioSelect";
import CardTextInput from "../CardTextInput/CardTextInput";
import { PATTERN, SLACK_WEBHOOKS_DOCS_URL } from "../../constants";

interface CardNotificationsProps {
  slackWebhookUrl: string;
  webMethod: string;
  webUrl: string;
  onChange: Function;
  disabled?: boolean;
}

export default function CardNotifications(props: CardNotificationsProps) {
  const [slackNotification, setSlackNotification] = useState(false);
  const [webNotification, setWebNotification] = useState(false);
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "slack") {
      setSlackNotification(value);
    }
    if (name === "web") {
      setWebNotification(value);
    }
  };

  return (
    <div className="container bg-white border-bottom rounded-bottom rounded-top mb-143-rem">
      <Card title="Notifications" innerCard={true}>
        <Form.Group
          className={
            "row ps-171-rem pe-186-rem pt-5" +
            (slackNotification ? " pb-0" : " pb-257-rem")
          }
        >
          <Form.Check
            type="checkbox"
            id="slack"
            label={t("SLACK")}
            name="slack"
            className="text-gray-36 m-0"
            onChange={handleChange}
            checked={slackNotification}
            disabled={props.disabled}
          />
        </Form.Group>
        {slackNotification && (
          <Form.Group className="ps-171-rem my-179-rem">
            <Form.Label
              className="font-weight-600 px-0 pb-2 ms--075-rem"
              htmlFor="slackWebhookUrl"
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={SLACK_WEBHOOKS_DOCS_URL}
              >
                {t("How to get Slack webhook URL?")}
              </a>
            </Form.Label>
            <Form.Control
              className="bg-white py-075-rem ms--075-rem"
              type="text"
              id="slackWebhookUrl"
              name="slackWebhookUrl"
              value={props.slackWebhookUrl}
              onChange={(value) => {
                props.onChange(value);
              }}
              placeholder={t("Enter Slack webhook URL")}
              required
              disabled={props.disabled}
              pattern={PATTERN.URL}
            />
            <Form.Control.Feedback type="invalid">
              {props.slackWebhookUrl && props.slackWebhookUrl.length > 0
                ? t("Slack webhook URL is invalid!")
                : t("Slack webhook URL is missing!")}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        <Form.Group className="row ps-171-rem pe-186-rem">
          <Form.Check
            type="checkbox"
            id="web"
            label={t("WEB")}
            name="web"
            className={"text-gray-36 m-0" + (webNotification ? "" : " pb-5")}
            onChange={handleChange}
            checked={webNotification}
            disabled={props.disabled}
          />
        </Form.Group>
      </Card>
      {webNotification && (
        <>
          <CardRadioSelect
            innerCard={true}
            name="webMethod"
            options={[
              {
                name: "methodGET",
                label: "GET",
                value: "GET",
              },
              {
                name: "methodPOST",
                label: "POST",
                value: "POST",
              },
              {
                name: "methodPUT",
                label: "PUT",
                value: "PUT",
              },
            ]}
            value={props.webMethod}
            onChange={props.onChange}
            requiredText="Please select method!"
            disabled={props.disabled}
          />
          <CardTextInput
            innerCard={true}
            inputs={[
              {
                name: "webUrl",
                placeholder: "Web URL",
                requiredText: "Web URL is missing!",
                value: props.webUrl,
                onChange: props.onChange,
                pattern: PATTERN.URL,
                patternViolationText: "Web URL is invalid!",
              },
            ]}
            disabled={props.disabled}
          />
        </>
      )}
    </div>
  );
}
